import * as React from 'react'
import { Modal } from 'antd'

const AfterPayModal: React.FC<{
    visible?: boolean
    onConfirm?: () => void
    onCancel?: () => void
}> = ({
    visible = false,
    onConfirm,
    onCancel
}) => {
    return (
        <Modal
            visible={visible}
            okText='已完成付款'
            onOk={onConfirm}
            onCancel={onCancel}
        >
            <p style={{ width: '100%', textAlign: 'center', marginBottom: '10px' }}>温馨提示</p>
            <p style={{ width: '100%', textAlign: 'center' }}>正为您打开支付页面，支付完成前请不要关闭此窗口</p>
        </Modal>
    )
}

export default AfterPayModal